import { companyApis } from '@apis/companyApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const useCompanyStaffDelete = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (id: number) => {
      const response = await companyApis.delete('/company/staff/{id}/', {
        path: { id },
      });
      return response[200];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (q) => Array.isArray(q.queryKey) && q.queryKey[0] === '/company/staff/',
        });
      },
    },
  );
};
